import React from 'react'
import { Button } from 'semantic-ui-react'

const FraudDetectionToggle = ({ loading, onClick, disabled, detectable }) => {
  return (
    <Button
      size="mini"
      loading={loading}
      onClick={onClick}
      disabled={disabled}
      labelPosition="right"
      content="Fraud Detection"
      color={detectable ? 'green' : 'red'}
      icon={detectable ? 'lock' : 'unlock'}
      style={{ width: 120, margin: 0, marginTop: 5 }}
    />
  )
}

export default FraudDetectionToggle



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ActionButtons/FraudDetection.js